export default __webpack_public_path__ + "media/projects/purple3-90195c3e.svg";